// extracted by mini-css-extract-plugin
module.exports =  {"volume-control":"uEhuvau","volumeControl":"uEhuvau","on":"W5_gbVt","off":"jcJMilJ"};